import { jsxs as l, jsx as h } from "react/jsx-runtime";
const o = (c) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...c,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M47.357 12.04h-5.453V6.06H24.276c-1.654 0-3 1.346-3 3v2.98h-1.404a4.053 4.053 0 0 0-4.049 4.048v33.306a4.188 4.188 0 0 0 4.183 4.184h1.27v1.26a3.089 3.089 0 0 0 3.086 3.086h17.542v-4.346h2.533l-1.074-4.008 3.994-1.07V12.04Zm-24.08-2.98c0-.552.448-1 1-1h15.627v3.98h-7.13v-2.1h-2v2.1h-7.498V9.06Zm16.627 46.864H24.362a1.087 1.087 0 0 1-1.086-1.085v-1.261h16.628v2.346Zm3.453-6.346h-23.35a.183.183 0 0 1-.184-.184V20.602h23.534v28.976Zm0-30.976H19.823v-2.514c0-.027.022-.049.049-.049h23.485v2.563Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "m31.895 45.203.073-.001H32l.08-.001c7.229-.08 8.368-4.778 7.843-8.251-.591-3.913-5.61-9.09-5.61-9.09l-1.25 1.35-1.168-4.413s-7.107 7.466-7.849 12.435c-.532 3.567 1.542 7.97 7.849 7.97Zm1.78-2.565c-.604.395-1.298.543-1.608.562l-.102.002c-.291-.011-1.014-.154-1.64-.564-.799-.523-.901-1.13-.901-1.598 0-.721.603-1.742 1.654-2.8.315-.318.634-.602.922-.843.288.241.607.526.922.843 1.051 1.059 1.654 2.08 1.654 2.8 0 .469-.102 1.074-.901 1.598Zm-7.65-5.11c.249-1.673 1.598-4.21 3.798-7.142.377-.502.75-.98 1.107-1.42l.2.757.932 3.515 2.217-2.396c1.477 1.797 3.374 4.472 3.666 6.407.358 2.368-.414 3.682-.906 4.254-.172.2-.368.38-.587.545a4.05 4.05 0 0 0 .124-1.008c0-3.172-4.576-6.145-4.576-6.145s-4.576 2.972-4.576 6.145c0 .29.028.563.08.818a4.187 4.187 0 0 1-.442-.44c-.864-1.002-1.252-2.456-1.038-3.89Z"
        }
      )
    ]
  }
);
export {
  o as Lpg
};
